declare const FeBlazorLibrary: {
  localStorage: {
    setItem: (key: string, value: string) => void;
  };
};

export default class Theming {
  /**
   * Changes the theme of the application.
   * @param {any} theme The theme to change to (ex. light, dark, default)
   */
  static changeTheme(theme: any) {
    // set to light, dark, default
    document.querySelector('html')!.setAttribute('data-fe-theme', theme);

    // TODO come up with a better way to handle this dynamically
    // special case for known theme files
    var activeLinkEles = document.querySelector('link.highlightTheme[data-fe-theme="' + theme + '"]');
    if (activeLinkEles) {
      activeLinkEles.removeAttribute("disabled");
    }

    // disable all other theme files
    document.querySelectorAll('link.highlightTheme:not([data-fe-theme="' + theme + '"])')
      .forEach(function (link) {
        link.setAttribute("disabled", "disabled");
      });

    FeBlazorLibrary.localStorage.setItem('fe-theme', theme);
  }

  /**
   * Gets the active theme of the application.
   * @returns {string} The active theme.
   */
  static getActiveTheme(): string | null {
    return document.querySelector('html')!.getAttribute('data-fe-theme');
  }
}
